$(()=> {
  // let formChangePassword = $('#form-change-password');

  // let changePassword = async (e) => {
  //   e.preventDefault();

  //   let el = $(e.currentTarget);
  //   let method = el.attr('method');
  //   let action = el.attr('action');

  //   let isValid = el.valid();

  //   console.log(method, action);

  //   if (isValid) {
  //     try {
  //       let response = await fetch('')
  //     } catch (error) {
  //       console.log('error: ', error);
  //     }
  //   }
  // }

  // formChangePassword.on('submit', changePassword);

  $('#btnDeleteAccount').on('click', async (e)=> {

    if (confirm('¿Seguro que deseas eliminar tú cuenta?')) {
      try {
        let response = await fetch('/users/delete', {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        })

        let data = await response.json();

        if (data.success) {
          location.reload();
        }


      } catch (error) {
        console.error('error: ', error);
      }
    }
  });
});
